// extracted by mini-css-extract-plugin
module.exports = {"full-width-hero-ornament":"Hero_full-width-hero-ornament__eqtTq","full-width-hero-content":"Hero_full-width-hero-content__QTRHv"};